import { Close } from '@mui/icons-material'
import { Button, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, TextField, Typography } from '@mui/material'
import { Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'

const CreatePaymentMethod = ({open, closeWindow, onSubmit }) => {
    const validationSchema =
        Yup.object().shape({
            payment_method: Yup.string().required('Payment Method is required')
        })
    
return (
    <Dialog maxWidth={'xs'}
        fullWidth
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    open={open}
            >
                    <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }} >
                            Create Payment Method
                            <IconButton
                                    component="span"
                                    size='small'
                                    sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                                    onClick={closeWindow}
                                    variant="contained"
                            >
                                    <Close />
                            </IconButton>
                    </DialogTitle>
                    <Divider/>
                    <DialogContent>
                            <Grid container direction={'column'}>
                                    <Grid item>
                                            <Formik
                                                    initialValues={{
                                                            payment_method: ''
                                                    }}
                                                    onSubmit={(values)=>onSubmit(values)}
                                                    validationSchema={validationSchema}
                                            >
                                                    {({ values, handleChange, handleBlur, handleSubmit, touched, errors }) => (
                                                            <form onSubmit={handleSubmit}>
                                                                    <Grid container direction={'column'}>
                                                                            <Grid item sm>
                                                                                    <TextField
                                                                                            fullWidth
                                                                                            margin="normal"
                                                                                            name="payment_method"
                                                                                            label="Payment Method"
                                                                                            value={values.payment_method}
                                                                                            error={Boolean(touched.payment_method && errors.payment_method)}
                                                                                            helperText={touched.payment_method && errors.payment_method}
                                                                                            onBlur={handleBlur}
                                                                                            onChange={handleChange}
                                                                                            my={2}
                                                                                    />
                                                                            </Grid>
                                                                    </Grid>
                                                                            <Grid container mt={5} justifyContent="flex-end">
                                                                            <Grid item>
                                                                            <Button
                                                                                    type="submit"
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    sx={{ margin: 'auto' }} // Add this line to center the button
                                                                            >
                                                                                    Create  
                                                                             </Button>
                                                                            </Grid> 
                                                                     </Grid>
                                
                                                            </form>)}
                                            </Formik>
                                    </Grid>
                            </Grid>
                    </DialogContent>
            </Dialog>
)
}

export default CreatePaymentMethod